import copy from 'copy-to-clipboard';
import Components from 'mpm-components';
import React from 'react';
import { Button, Dropdown, Form, Icon, Popup } from 'semantic-ui-react';

export default ({ declarationVente, editMode, pays }) => {
  return (
    <Components.Regions.RegionWithHeader title="label.declaration.vente" headerColor="blue" headerSize="small">
      <Form>
        <Form.Group widths="equal">
          <Form.Input
            type="text"
            readOnly
            label="Numéro déclaration vente"
            value={declarationVente.numeroDV}
            onChange={(event) => {
              event.preventDefault();
            }}
            action={
              <Popup
                content="Copier"
                trigger={
                  <Button icon onClick={() => copy(declarationVente.numeroDV)}>
                    <Icon name="copy" />
                  </Button>
                }
              />
            }
          />
          <Form.Input label="Numéro visa" disabled value={declarationVente.numeroVisa} />
          <Form.Input label="Date Système" value={declarationVente.dateDeclaration} disabled />
        </Form.Group>
      </Form>
      <Components.Regions.RegionWithHeader title="label.especes" headerColor="blue" headerSize="small" className="scrolling-x">
        <Components.Tables.SmartTable
          data={declarationVente.childrenSrcEspeceDV || []}
          grouped={true}
          groupeBy="refEspece.libelle"
          groupeSums={['quantite']}
          header={[
            {
              selector: 'refEspece.libelle',
              textAlign: 'center',
              label: 'Espece',
            },
            {
              selector: 'id_refPaysExp',
              textAlign: 'center',
              label: "Pays d'expédition",
              component: (row) => <Dropdown name="id_refPaysExp" defaultValue={row.id_refPaysExp} options={pays.data} disabled />,
            },
            {
              selector: 'quantite',
              textAlign: 'center',
              label: 'Quantité',
            },
            {
              selector: 'valeur',
              textAlign: 'center',
              label: 'Valeur',
            },
            {
              selector: 'nbCaisses',
              textAlign: 'center',
              label: 'NB Caisses',
            },

            {
              selector: 'tailleCommerciale',
              textAlign: 'center',
              label: 'Taille Commerciale',
            },
          ]}
          pagination={false}
          striped={true}
          sortable={true}
        />
      </Components.Regions.RegionWithHeader>
    </Components.Regions.RegionWithHeader>
  );
};
